import Vue from "vue"

export const campaignsStore = {
  state: {
    campaigns: []
  },
  mutations: {
    SET_CAMPAIGNS(state, campaigns) {
      const order = { bachelor: 1, magistrant: 2, aspirant: 3, bachelor_additional: 4, magistrant_additional: 5 }
      const sortedCampaigns = campaigns.sort((a, b) =>
        order[a.education_level] - order[b.education_level]
      )
      Vue.set(state, 'campaigns', sortedCampaigns)
    },
  },
  actions: {
    async getCampaigns({state, commit }) {
      try {
        const data = await Vue.http.get("/api/v1/campaigns")
        commit("SET_CAMPAIGNS", data.body.campaigns)
        return data
      } catch (error) {
        throw error
      }
    }
  }
}